import { render, staticRenderFns } from "./reload.vue?vue&type=template&id=20078cf9&"
import script from "./reload.vue?vue&type=script&lang=js&"
export * from "./reload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports